import React, { useState, useEffect } from "react";
import { Box, Typography, Button, IconButton, Tooltip, TextField, MenuItem, Divider, CircularProgress, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogTitle, DialogContent, DialogActions, } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DataTable from "../components/DataTable";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import SnackbarAlert from "../components/SnackbarAlert";
export default function SalesEntry() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [search, setSearch] = useState("");
    const [productCategory, setProductCategory] = useState([]);
    const [productList, setProductList] = useState({});
    const [editState, setEditState] = useState(null);
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [open, setOpen] = useState(false);
    const [salesId, setSalesId] = useState("");
    const [salesDate, setSalesDate] = useState(new Date().toISOString().split("T")[0]);
    const [gstAmount, setGstAmount] = useState(0);
    const [customerName, setCustomerName] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [subTotal, setSubTotal] = useState(0);
    const [deduction, setDeduction] = useState(0);
    const [deductionRemarks, setDeductionRemarks] = useState("");
    const [totalWeight, setTotalWeight] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [openPreview, setOpenPreview] = useState(false);
    const [purchaseItems, setPurchaseItems] = useState([]);
    const [selectedPurchase, setSelectedPurchase] = useState(null);
    const [products, setProducts] = useState([{ category: "", productName: "", huid: "", qty: 1, weight: 0, price: 0, making: 0, stone: 0, amount: 0, productDetails: null },]);
    useEffect(() => {
        setSalesId(`SAL-${new Date().getFullYear()}-${Date.now().toString().slice(-4)}`);
    }, []);
    useEffect(() => {
        calculateTotals();
    }, [products, deduction]);
    useEffect(() => {
        fetchPurchaseData();
    }, []);
    const fetchPurchaseData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "product-sales";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "productcategory";
            const response = await makeRequest("get", url);
            if (response) {
                setProductCategory(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const calculateTotals = () => {
        let weight = 0;
        let subtotal = 0;
        products.forEach((item) => {
            weight += Number(item.weight || 0);
            subtotal += Number(item.amount || 0);
        });
        const gst = (subtotal * 3) / 100;
        const grandTotal = subtotal + gst;
        setTotalWeight(weight);
        setSubTotal(subtotal);
        setGstAmount(gst);
        setTotalAmount(grandTotal);
    };
    const addProductRow = () => {
        setProducts([...products, { category: "", productName: "", huid: "", qty: 1, weight: "", price: "", making: "", stone: "", amount: 0, },]);
    };
    const removeProductRow = (index) => {
        const updated = [...products];
        updated.splice(index, 1);
        setProducts(updated);
    };
    const handleProductChange = (index, field, value) => {
        const updated = [...products];
        updated[index][field] = ["huid_no", "qty", "weight", "price", "making", "stone"].includes(field) ? Number(value) : value;
        if (field === "category") {
            updated[index].productName = "";
            fetchProductsByCategory(value, index);
        }
        if (field === "productName") {
            const selectedProduct =
                productList[index]?.find(
                    p => p.rfId === value
                );
            if (selectedProduct) {
                updated[index].weight =
                    Number(
                        selectedProduct.net_weight ||
                        selectedProduct.weight ||
                        0
                    );
                updated[index].price = Number(selectedProduct.price || selectedProduct.rate_per_gram || 0);
                updated[index].productDetails = selectedProduct;
            }
        }
        const huid = updated[index].huid || "";
        const qty = Number(updated[index].qty) || 0;
        const weight = Number(updated[index].weight) || 0;
        const price = Number(updated[index].price) || 0;
        const making = Number(updated[index].making) || 0;
        const stone = Number(updated[index].stone) || 0;
        updated[index].amount = (qty * weight * price) + (making + stone);
        setProducts(updated);
        calculateTotals(updated);
    };
    const handleSave = async () => {
        if (!customerName?.trim()) {
            setMessage("Customer Name is required");
            setSnackbar(true);
            return;
        }
        if (!mobileNo?.trim()) {
            setMessage("Mobile Number is required");
            setSnackbar(true);
            return;
        }
        if (!/^[0-9]{10}$/.test(mobileNo)) {
            setMessage("Please enter a valid 10-digit Mobile Number");
            setSnackbar(true);
            return;
        }
        if (!salesDate) {
            setMessage("Sales Date is required");
            setSnackbar(true);
            return;
        }
        if (!products || products.length === 0) {
            setMessage("Please add at least one product");
            setSnackbar(true);
            return;
        }
        for (const item of products) {
            if (!item.productName) {
                setMessage("Please select Product");
                setSnackbar(true);
                return;
            }
            if (!item.qty || Number(item.qty) <= 0) {
                setMessage("Please enter valid Quantity");
                setSnackbar(true);
                return;
            }
            if (!item.weight || Number(item.weight) <= 0) {
                setMessage("Please enter valid Weight");
                setSnackbar(true);
                return;
            }
            if (!item.price || Number(item.price) <= 0) {
                setMessage("Please enter valid Rate");
                setSnackbar(true);
                return;
            }
            if (!item.amount || Number(item.amount) <= 0) {
                setMessage("Please enter valid Amount");
                setSnackbar(true);
                return;
            }
        }

        if (!totalAmount || Number(totalAmount) <= 0) {
            setMessage("Total Amount should be greater than 0");
            setSnackbar(true);
            return;
        }
        try {
            setLoading(true);
            const salesPayload = {
                sales_no: salesId,
                customer_id: "",
                customer_name: customerName,
                customer_mobile: mobileNo,
                sales_date: salesDate,
                total_product_amount: 0,
                total_making_charges: 0,
                total_gst_amount: gstAmount,
                discount_amount: 0,
                grand_total: totalAmount,
                payment_mode: "CASH",
                payment_status: "SUCCESS",
                razorpay_payment_id: "",
                estimate_status: "CONFIRMED",
                notes: deductionRemarks,
                isActive: 0
            };
            const salesResponse = await makeRequest("post", webEndPoint + "product-sales", salesPayload);
            const sales_id = salesResponse.data.rfId;
            for (const item of products) {
                const itemAmount = Number(item.amount || 0);
                const gst = itemAmount * 0.03;
                const salesItemPayload = {
                    sales_id,
                    product_id: item.productName,
                    huid_no: item.huid,
                    qty: item.qty || 1,
                    gross_weight: item.weight || 0,
                    net_weight: item.weight || 0,
                    rate_per_gram: item.price || 0,
                    metal_amount: itemAmount,
                    making_charges: item.making || 0,
                    wastage_amount: item.stone,
                    gst_percent: 3,
                    gst_amount: gst,
                    total_amount: itemAmount + gst
                };
                await makeRequest("post", webEndPoint + "product-sales-item", salesItemPayload);
            }
            setMessage("Sales Saved Successfully");
            setSnackbar(true);
            resetForm();
            setOpen(false);
            fetchPurchaseData();
        } catch (err) {
            console.error(err);
            setMessage(err?.response?.data?.message || err.message);
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };
    const fetchProductsByCategory = async (categoryId, index) => {
        setLoading(true);
        try {
            let url = webEndPoint + "billing-products/category/" + categoryId;
            const response = await makeRequest("get", url);
            if (response) {
                setProductList(prev => ({ ...prev, [index]: response.data }));
                setLoading(false);
            }
        } catch (err) {
            setLoading(false);
            console.error(err);
        }
    };
    const resetForm = () => {
        setSalesId(`SAL-${new Date().getFullYear()}-${Date.now().toString().slice(-4)}`);
        setSalesDate(new Date().toISOString().split("T")[0]);
        setCustomerName("");
        setDeductionRemarks("");
        setMobileNo("");
        setSubTotal(0);
        setGstAmount(0);
        setTotalWeight(0);
        setTotalAmount(0);
        setProducts([{ category: "", productName: "", huid: "", qty: 1, weight: "", price: "", making: "", stone: "", amount: 0, productDetails: null }]);
    };
    const openAdd = () => {
        setEditState(null);
        resetForm();
        setOpen(true);
    };
    const openEdit = (data) => {
        setEditState(data);
        // setCategory(data?.product_category_id);
        // setProductName(data?.product_name);
        setOpen(true);
    };
    const formatDateTime = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12;
        return `${day}-${month}-${year}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
    };
    const formatDate = (date) => {
        return new Date(date).toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
    };
    const handleViewPurchase = async (row) => {
        try {
            setLoading(true);
            setSelectedPurchase(row);
            const response = await makeRequest("get", webEndPoint + "product-sales-item/sales/" + row.rfId);
            if (response) {
                setPurchaseItems(response?.data || []);
                setOpenPreview(true);
            }
        } catch (err) {
            console.error(err);
            setMessage("Failed to load purchase items");
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };
    const downloadInvoice = async (salesId) => {
        try {
            setLoading(true);
            const response = await makeRequest("get", webEndPoint + "product-sales/invoice/" + salesId);
            if (response?.url) {
                window.open(response.url, "_blank");
            }
        } catch (error) {
            console.error("Invoice download failed:", error);
            setMessage("Failed to load purchase items");
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };
    // const filteredState = dataSource?.filter((d) =>
    //     d?.customer_name?.toLowerCase().includes(search?.toLowerCase()) || d?.customer_mobile?.toLowerCase().includes(search?.toLowerCase())
    // );
    const filteredState = dataSource?.filter((d) => {
        const customerName = d?.customer_name?.toLowerCase() || "";
        const customerMobile = d?.customer_mobile?.toLowerCase() || "";
        const searchText = search?.toLowerCase() || "";
        return (
            !customerName.includes("muthoot exim pvt ltd") &&
            (
                customerName.includes(searchText) ||
                customerMobile.includes(searchText)
            )
        );
    });
    const columns = ["S.No", "Sales No", "Date", "Customer", "Mobile", "GST", "Total Amount", "Action"];
    const rows = filteredState?.map((item, index) => [index + 1, item?.rfId, formatDate(item?.sales_date), item?.customer_name, item?.customer_mobile, `₹ ${item.total_gst_amount?.toLocaleString()}`, `₹ ${item.grand_total?.toLocaleString()}`,
    <Box>
        <Tooltip title="Preview">
            <IconButton color="info" onClick={() => handleViewPurchase(item)}><VisibilityIcon /></IconButton>
        </Tooltip>
        <Tooltip title="PDF">
            <IconButton color="primary" onClick={() => downloadInvoice(item?.rfId)}><PrintIcon /></IconButton>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Sales Bill</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search Customer Name / Mobile Number" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAdd}>Create Sales Bill</Button>
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />
            {open && (
                <Box component="div" sx={{ position: "fixed", top: 60, left: 0, width: "100%", height: "100%", bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200 }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: "90%", height: "80%", display: "flex", flexDirection: "column", overflow: "hidden", gap: 2 }}>
                        <Box sx={{ width: "100%", display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 2, pb: 2, borderBottom: "1px solid #e0e0e0" }}>
                            <Typography variant="h6" fontWeight={600}>Sales Details</Typography>
                            <TextField label="Sales ID" value={salesId} disabled />
                            <TextField label="Sales Date" type="date" value={salesDate}
                                onChange={(e) => setSalesDate(e.target.value)} InputLabelProps={{ shrink: true, }} />
                            <TextField label="Customer Name" value={customerName} onChange={(e) => setCustomerName(e.target.value)} fullWidth />
                            <TextField label="Mobile Number" value={mobileNo} onChange={(e) => setMobileNo(e.target.value)} fullWidth />
                            <TextField label="Sub Total" value={subTotal} disabled fullWidth />
                            <TextField label="GST (3%)" value={gstAmount.toFixed(2)} disabled fullWidth />
                            <TextField label="Total Weight" value={totalWeight} disabled fullWidth />
                            <TextField label="Total Amount" value={totalAmount} disabled fullWidth />
                            <TextField label="Other Details" value={deductionRemarks} onChange={(e) => setDeductionRemarks(e.target.value)} multiline rows={1} fullWidth />
                        </Box>
                        <Box sx={{ width: "100%", flex: 1, overflowY: "auto", pl: 1, display: "flex", flexDirection: "column" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }}>
                                <Typography variant="h6" fontWeight={600}>Product Details</Typography>
                                <Button variant="contained" startIcon={<AddIcon />} onClick={addProductRow}>Add Product</Button>
                            </Box>
                            <Divider sx={{ mb: 2 }} />
                            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 0.8fr 0.8fr 0.8fr 0.8fr 1fr 1fr 1fr 60px", gap: 1, mb: 2, fontWeight: 600, }}>
                                <Typography>Category</Typography>
                                <Typography>Product</Typography>
                                <Typography>HUID No</Typography>
                                <Typography>Qty</Typography>
                                <Typography>Weight(G)</Typography>
                                <Typography>Price(G)</Typography>
                                <Typography>M.Charge</Typography>
                                <Typography>Stone Rate</Typography>
                                <Typography>Amount</Typography>
                                <Typography></Typography>
                            </Box>
                            {products.map(
                                (item, index) => (
                                    <Box key={index} sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 0.8fr 0.8fr 0.8fr 0.8fr 1fr 1fr 1fr 60px", gap: 1, mb: 2, }}>
                                        <TextField select size="small" value={item.category}
                                            onChange={(e) => handleProductChange(index, "category", e.target.value)}>
                                            {productCategory?.map((cat) => (<MenuItem key={cat?.rfId} value={cat?.rfId}>{cat?.category_name}</MenuItem>))}
                                        </TextField>
                                        <TextField select size="small" value={item.productName}
                                            onChange={(e) => handleProductChange(index, "productName", e.target.value)}>
                                            {productList[index]?.map((item) => (<MenuItem key={item.rfId} value={item.rfId}>{item.product_name}</MenuItem>))}
                                        </TextField>
                                        <TextField size="small" value={item.huid}
                                            onChange={(e) => handleProductChange(index, "huid", e.target.value)} />
                                        <TextField size="small" type="number" value={item.qty}
                                            onChange={(e) => handleProductChange(index, "qty", e.target.value)} />
                                        <TextField size="small" type="number" value={item.weight}
                                            onChange={(e) => handleProductChange(index, "weight", e.target.value)} />
                                        <TextField size="small" type="number" value={item.price}
                                            onChange={(e) => handleProductChange(index, "price", e.target.value)} />
                                        <TextField size="small" type="number" value={item.making}
                                            onChange={(e) => handleProductChange(index, "making", e.target.value)} />
                                        <TextField size="small" type="number" value={item.stone}
                                            onChange={(e) => handleProductChange(index, "stone", e.target.value)} />
                                        <TextField size="small" value={item.amount} disabled />
                                        <IconButton color="error" onClick={() => removeProductRow(index)}><DeleteIcon /></IconButton>
                                    </Box>
                                )
                            )}
                            <Box sx={{ position: "sticky", bottom: 0, backgroundColor: "#fff", borderTop: "1px solid #e0e0e0", pt: 2, mt: 2, display: "flex", justifyContent: "flex-end", gap: 2, zIndex: 10 }}>
                                <Button variant="outlined" color="error" size="large" onClick={() => setOpen(false)}>Close</Button>
                                <Button variant="contained" size="large" onClick={handleSave}>Generate GST Bill</Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            )}
            <Dialog open={openPreview} onClose={() => setOpenPreview(false)} maxWidth="lg" fullWidth>
                <DialogTitle sx={{ fontWeight: 600, fontSize: 24 }}>Sales Details</DialogTitle>
                <DialogContent>
                    <Paper elevation={0} sx={{ p: 2, mb: 3, background: "#f8f8f8" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Sales No</Typography>
                                <Typography>{selectedPurchase?.rfId}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Customer Name</Typography>
                                <Typography>{selectedPurchase?.customer_name}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Mobile Number</Typography>
                                <Typography>{selectedPurchase?.customer_mobile}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Sales Date</Typography>
                                <Typography>{formatDate(selectedPurchase?.sales_date)}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>GST Amount</Typography>
                                <Typography>{selectedPurchase?.total_gst_amount}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Total Amount</Typography>
                                <Typography>₹ {Number(selectedPurchase?.grand_total || 0).toLocaleString()}</Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Typography fontWeight={600}>Other Deatils</Typography>
                    <Typography>{selectedPurchase?.notes}</Typography><br />
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">#</TableCell>
                                    <TableCell>Product</TableCell>
                                    <TableCell>HUID No</TableCell>
                                    <TableCell align="center">Qty</TableCell>
                                    <TableCell align="right">Weight</TableCell>
                                    <TableCell align="right">Rate</TableCell>
                                    <TableCell align="right">Making</TableCell>
                                    <TableCell align="right">Stone</TableCell>
                                    <TableCell align="right">Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {purchaseItems?.map((item, index) => (
                                    <TableRow key={item?.rfId}>
                                        <TableCell align="center">{index + 1}</TableCell>
                                        <TableCell>{item?.product_name}</TableCell>
                                        <TableCell>{item?.huid_no}</TableCell>
                                        <TableCell align="center">{item?.qty}</TableCell>
                                        <TableCell align="right">{Number(item?.net_weight).toFixed(3)}</TableCell>
                                        <TableCell align="right">₹ {Number(item?.rate_per_gram).toLocaleString()}</TableCell>
                                        <TableCell align="right">₹ {Number(item?.making_charges).toLocaleString()}</TableCell>
                                        <TableCell align="right">₹ {Number(item?.wastage_amount).toLocaleString()}</TableCell>
                                        <TableCell align="right">₹ {Number(item?.total_amount).toLocaleString()}</TableCell>
                                    </TableRow>
                                )
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => setOpenPreview(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
        </Box>
    );
}